import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "layout-topbar" }
const _hoisted_2 = { class: "topbar-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "topbar-separator" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  id: "logo-mobile",
  class: "mobile-logo",
  src: "/assets/features/images/logo-dark.svg",
  alt: "logo"
}, null, -1)
const _hoisted_7 = { class: "topbar-right" }
const _hoisted_8 = { class: "topbar-menu" }
const _hoisted_9 = {
  key: 1,
  class: "website-item"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "search-item"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-flag" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-palette" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user profile-image" }, null, -1)
const _hoisted_21 = { class: "profile-name" }
const _hoisted_22 = { class: "profile-menu fade-in-up" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-power-off" }, null, -1)
const _hoisted_25 = { class: "right-sidebar" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBarLeftHolder = _resolveComponent("TopBarLeftHolder")!
  const _component_TopBarRightHolder = _resolveComponent("TopBarRightHolder")!
  const _component_OfflineComponent = _resolveComponent("OfflineComponent")!
  const _component_NotificationSelector = _resolveComponent("NotificationSelector")!
  const _component_LocaleSelector = _resolveComponent("LocaleSelector")!
  const _component_ThemeSelector = _resolveComponent("ThemeSelector")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        tabindex: "0",
        class: "menu-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMenuButtonClick && _ctx.onMenuButtonClick(...args)))
      }, _hoisted_4),
      _hoisted_5,
      _createVNode(_component_TopBarLeftHolder),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createVNode(_component_TopBarRightHolder),
        (_ctx.config.database.offlineMode === true && _ctx.user.canViewUI('offline'))
          ? (_openBlock(), _createBlock(_component_OfflineComponent, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.config.url.public != '')
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _createElementVNode("a", {
                href: _ctx.config.url.public,
                target: "_blank"
              }, _hoisted_12, 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true),
        (_ctx.config.app.search === true && _ctx.user.canViewUI('search'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearchClick && _ctx.onSearchClick(...args)))
              }, _hoisted_15)
            ]))
          : _createCommentVNode("", true),
        (_ctx.user.canViewUI('notification'))
          ? (_openBlock(), _createBlock(_component_NotificationSelector, {
              key: 3,
              topbarNotificationMenuActive: _ctx.topbarNotificationMenuActive,
              onTopbarNotification: _ctx.onTopbarNotificationMenuButtonClick
            }, null, 8, ["topbarNotificationMenuActive", "onTopbarNotification"]))
          : _createCommentVNode("", true),
        (_ctx.config.app.locale.use && _ctx.config.app.locale.locales.length > 0)
          ? (_openBlock(), _createElementBlock("li", {
              key: 4,
              class: _normalizeClass(["lang-item", { 'active-menuitem fadeInDown': _ctx.topbarLangMenuActive }])
            }, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onTopbarLangMenuButtonClick && _ctx.onTopbarLangMenuButtonClick(...args)))
              }, _hoisted_17),
              _createVNode(_component_LocaleSelector)
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("li", {
          class: _normalizeClass(["theme-item", { 'active-menuitem fadeInDown': _ctx.topbarThemeMenuActive }])
        }, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onTopbarThemeMenuButtonClick && _ctx.onTopbarThemeMenuButtonClick(...args)))
          }, _hoisted_19),
          _createVNode(_component_ThemeSelector)
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["profile-item", { 'active-menuitem fadeInDown': _ctx.topbarUserMenuActive }])
        }, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onTopbarUserMenuButtonClick && _ctx.onTopbarUserMenuButtonClick(...args)))
          }, [
            _hoisted_20,
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.username), 1)
          ]),
          _createElementVNode("ul", _hoisted_22, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: '/profile' }, {
                default: _withCtx(() => [
                  _hoisted_23,
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("gen.profile")), 1)
                ]),
                _: 1
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.app.profileMenuItems, (menuItem, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                (_ctx.user.hasAnyViewUIRight([menuItem.requiredModule]))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: menuItem.path
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(`pi pi-${menuItem.icon}`)
                        }, null, 2),
                        _createElementVNode("span", null, _toDisplayString(_ctx.t(`buttons.${menuItem.text}`)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.logoutAction()))
              }, [
                _hoisted_24,
                _createElementVNode("span", null, _toDisplayString(_ctx.t("gen.logout")), 1)
              ])
            ])
          ])
        ], 2),
        _createElementVNode("li", _hoisted_25, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onRightMenuClick && _ctx.onRightMenuClick(...args)))
          }, _hoisted_27)
        ])
      ])
    ])
  ]))
}